import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";

class AdminPagarmeCyclesModule extends HttpFactory {
  async getCycles(providerSubscriptionId: string): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.CYCLES}`,
      { provider_subscription_id: providerSubscriptionId },
    );
  }

  async getCycle(
    cycleId: string,
    providerSubscriptionId: string,
  ): Promise<any[]> {
    return await this.get<any[]>(
      `${ENDPOINTS.ADMIN.PAYMENT.PAGARME_PROXY.CYCLES}${cycleId}`,
      { provider_subscription_id: providerSubscriptionId },
    );
  }
}

export { AdminPagarmeCyclesModule };
